class DateClass {
  // 20201210 → 2020-12-10 T00:00:00
  formingDate (val: string|number) {
    let stringVal = val.toString()
    const y = stringVal.slice(0, 4)
    const m = stringVal.slice(4, 6)
    const d = stringVal.slice(6, 8)
    stringVal = `${y}-${m}-${d}T00:00:00`

    let date = new Date(stringVal)
    return date
  }

  displayData (val: number) {
    let displayDate = this.formingDate(val).getMonth() + 1 + '月' + this.formingDate(val).getDate() + '日'
    return displayDate
  }

  formingMMdd (val: string) {
    let date = new Date(val)
    if (date.toString() === 'Invalid Date') {
      return ''
    }
    let displayDate = date.getMonth() + 1 + '月' + date.getDate() + '日'
    return displayDate
  }

  setWeek (val: number) {
    const week = ['日', '月', '火', '水', '木', '金', '土']
    const weekDay = this.formingDate(val).getDay()

    return week[weekDay]
  }

  setWeek2 (date: any) {
    if (date !== null) {
      const week = ['日', '月', '火', '水', '木', '金', '土']
      const weekDay = date.getDay()

      return '(' + week[weekDay] + ')'
    }
    return ''
  }

  /* 月・日を二桁表示(0あり) */
  toDoubleDigits (val: number) {
    var data = val.toString()
    data += ''
    if (data.length === 1) {
      data = '0' + data
    }
    return data
  }

  /* 作付け日から収穫適期(最高)までの日数計算 */
  daysCalculation (date1: number, date2: number) {
    var day1 = this.formingDate(date1)
    var day2 = this.formingDate(date2)
    let days = (day2.getTime() - day1.getTime()) / (1000 * 60 * 60 * 24)

    return days
  }

  displayHarvestLimit (limitDay: number) {
    if (limitDay === null || limitDay === undefined || limitDay >= 0) {
      return '収穫適期まで'
    } else {
      return '収穫適期から'
    }
  }

  displayHarvestLimitDay (limitDay: number) {
    if (limitDay === null || limitDay === undefined) {
      return '-日'
    } else if (limitDay >= 0) {
      return limitDay + '日'
    } else if (limitDay <= -20) {
      return '20日以上超過'
    } else {
      return -(limitDay) + '日超過'
    }
  }

  displayHarvestDay (limitDay: number, date: string) {
    if (limitDay !== null && limitDay >= 0 && date !== '') {
      let harvestDate = this.formingMMdd(date)
      if (harvestDate !== '') {
        return '(' + this.formingMMdd(date) + ')'
      }
    }

    return ''
  }

  dateToStringYmd (date: any, unit: string) {
    let formingDate = ''
    if (date !== '' && date !== null) {
      if (unit === '-') {
        formingDate = this.toDoubleDigits(date.getFullYear()) + '-' + this.toDoubleDigits(date.getMonth() + 1) + '-' + this.toDoubleDigits(date.getDate())
      } else if (unit === 'yyyyMMdd') {
        formingDate = this.toDoubleDigits(date.getFullYear()) + this.toDoubleDigits(date.getMonth() + 1) + this.toDoubleDigits(date.getDate())
      } else if (unit === '年月日') {
        formingDate = this.toDoubleDigits(date.getFullYear()) + '年' + this.toDoubleDigits(date.getMonth() + 1) + '月' + this.toDoubleDigits(date.getDate()) + '日'
      } else if (unit === '年月日時分') {
        formingDate = this.toDoubleDigits(date.getFullYear()) + '年' + this.toDoubleDigits(date.getMonth() + 1) + '月' + this.toDoubleDigits(date.getDate()) + '日 ' + this.toDoubleDigits(date.getHours()) + ':' + this.toDoubleDigits(date.getMinutes())
      } else if (unit === '年月日曜日時分') {
        formingDate = this.toDoubleDigits(date.getFullYear()) + '年' + this.toDoubleDigits(date.getMonth() + 1) + '月' + this.toDoubleDigits(date.getDate()) + '日 ' + this.setWeek2(date) + ' ' + this.toDoubleDigits(date.getHours()) + ':' + this.toDoubleDigits(date.getMinutes())
      }
      return formingDate
    }
    return ''
  }

  dateToStringYmdhm (date: any, unit: string) {
    let formingDate = ''
    if (date !== '' && date !== null) {
      if (unit === '-') {
        formingDate = this.toDoubleDigits(date.getFullYear()) + '-' + this.toDoubleDigits(date.getMonth() + 1) + '-' + this.toDoubleDigits(date.getDate()) + ' ' + this.toDoubleDigits(date.getHours()) + ':' + this.toDoubleDigits(date.getMinutes())
      }
      return formingDate
    }
    return ''
  }

  dateToStringhms (date: any) {
    let formingDate = ''
    if (date !== '' && date !== null) {
      formingDate = this.toDoubleDigits(date.getHours()) + ':' + this.toDoubleDigits(date.getMinutes()) + ':' + this.toDoubleDigits(date.getSeconds())
      return formingDate
    }
    return ''
  }

  dateToStringMd (date: any, unit: string) {
    let formingDate = ''
    if (date !== '') {
      if (unit === '-') {
        formingDate = this.toDoubleDigits(date.getMonth() + 1) + '-' + this.toDoubleDigits(date.getDate())
      } else if (unit === '/') {
        formingDate = this.toDoubleDigits(date.getMonth() + 1) + '/' + this.toDoubleDigits(date.getDate())
      } else if (unit === '月日') {
        formingDate = this.toDoubleDigits(date.getMonth() + 1) + '月' + this.toDoubleDigits(date.getDate()) + '日'
      } else if (unit === '/曜日時分') {
        formingDate = this.toDoubleDigits(date.getMonth() + 1) + '/' + this.toDoubleDigits(date.getDate()) + this.setWeek2(date) + ' ' + this.toDoubleDigits(date.getHours()) + ':' + this.toDoubleDigits(date.getMinutes())
      }
      return formingDate
    }
    return ''
  }
}

export default new DateClass()
